import { queryOptions } from '@tanstack/react-query';
import { getCourses } from './get-courses';
import { getCourseDetail } from './get-course-detail';
import { getContents } from './get-contents';
import { getContentsDetail } from './get-contents-detail';
import { getUnresolvedQuizzes } from './get-unresolved-quizzes';
import type { GetCourseRequest } from '../model/dto';
import { getQuizzes } from './get-quizzes';

export const courseQueries = {
  all: ['courses'],
  lists: () => [...courseQueries.all, 'list'] as const,
  list: (params?: GetCourseRequest) =>
    queryOptions({
      queryKey: [...courseQueries.lists(), params] as const,
      queryFn: () => getCourses(params),
    }),
  detail: (id?: string) =>
    queryOptions({
      queryKey: [...courseQueries.all, 'detail', id] as const,
      queryFn: () => getCourseDetail(id),
      enabled: Boolean(id),
    }),
  contents: (params?: GetCourseRequest) =>
    queryOptions({
      queryKey: [...courseQueries.all, 'contents', params] as const,
      queryFn: () => getContents(params),
    }),
  contentDetail: (id: string) =>
    queryOptions({
      queryKey: [...courseQueries.all, 'content-detail', id] as const,
      queryFn: () => getContentsDetail(id),
      enabled: Boolean(id),
    }),
  unresolvedQuizzes: (id: string) =>
    queryOptions({
      queryKey: [...courseQueries.all, 'unresolved-quizzes', id] as const,
      queryFn: () => getUnresolvedQuizzes({ id }),
      enabled: Boolean(id),
    }),
  quizzes: (contentId: string) =>
    queryOptions({
      queryKey: [...courseQueries.all, 'quizzes', contentId] as const,
      queryFn: () => getQuizzes(contentId),
      enabled: Boolean(contentId),
    }),
};
